import React, { useState, useEffect } from 'react';
import axios from 'axios';

function PatientTracking() {
  const [patients, setPatients] = useState([]);
  const [treatments, setTreatments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('patients');
  const [modal, setModal] = useState({ open: false, type: null, data: null });
  const [form, setForm] = useState({});
  const [customerQuery, setCustomerQuery] = useState('');
  const [customerResults, setCustomerResults] = useState([]);
  const [newCustomerMode, setNewCustomerMode] = useState(false);
  const [newCustomer, setNewCustomer] = useState({ first_name: '', last_name: '', phone: '' });
  const token = localStorage.getItem('crm_token');
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => { fetchAll(); }, []);

  const fetchAll = async () => {
    setLoading(true);
    try {
      const [p, t] = await Promise.all([
        axios.get('/api/health-tourism/patients', { headers }),
        axios.get('/api/health-tourism/treatments', { headers })
      ]);
      setPatients(Array.isArray(p.data) ? p.data : [
        { id: 1, first_name: 'John', last_name: 'Smith', phone: '+1 555 987 6543', nationality: 'USA', treatment_type: 'Dental', travel_date: '2026-06-01', status: 'approved' },
        { id: 2, first_name: 'Helga', last_name: 'Müller', phone: '+49 176 123456', nationality: 'Germany', treatment_type: 'Hair Transplant', travel_date: '2026-06-05', status: 'consultation' }
      ]);
      setTreatments(Array.isArray(t.data) ? t.data : [
        { id: 101, first_name: 'John', last_name: 'Smith', treatment_name: 'Implants & Crown', doctor_name: 'Dr. Ahmet Yılmaz', scheduled_date: '2026-06-02', package_price: 8500, status: 'confirmed' }
      ]);
    } catch (e) {
      console.error(e);
      setPatients([
        { id: 1, first_name: 'John', last_name: 'Smith', phone: '+1 555 987 6543', nationality: 'USA', treatment_type: 'Dental', travel_date: '2026-06-01', status: 'approved' },
        { id: 2, first_name: 'Helga', last_name: 'Müller', phone: '+49 176 123456', nationality: 'Germany', treatment_type: 'Hair Transplant', travel_date: '2026-06-05', status: 'consultation' }
      ]);
      setTreatments([
        { id: 101, first_name: 'John', last_name: 'Smith', treatment_name: 'Implants & Crown', doctor_name: 'Dr. Ahmet Yılmaz', scheduled_date: '2026-06-02', package_price: 8500, status: 'confirmed' }
      ]);
    }
    setLoading(false);
  };

  const searchCustomers = async (q) => {
    setCustomerQuery(q);
    if (!q.trim()) { setCustomerResults([]); return; }
    try {
      const res = await axios.get(`/api/customers?search=${encodeURIComponent(q)}&limit=8`, { headers });
      setCustomerResults(Array.isArray(res.data?.data) ? res.data.data : []);
    } catch (e) { console.error(e); }
  };

  const selectCustomerForPatient = (c) => {
    setForm({ ...form, customer_id: c.id, first_name: c.first_name, last_name: c.last_name });
    setCustomerQuery(`${c.first_name} ${c.last_name || ''}`.trim());
    setCustomerResults([]);
  };

  const createCustomerForPatient = async () => {
    if (!newCustomer.first_name.trim() || !newCustomer.phone.trim()) {
      alert('Ad ve telefon zorunludur'); return;
    }
    try {
      const res = await axios.post('/api/customers', newCustomer, { headers });
      const c = res.data;
      selectCustomerForPatient(c);
      setNewCustomerMode(false);
      setNewCustomer({ first_name: '', last_name: '', phone: '' });
    } catch (e) { alert(e.response?.data?.error || 'Müşteri oluşturulamadı'); }
  };

  const savePatient = async () => {
    if (!form.id && !form.customer_id) {
      alert('Lütfen önce bir müşteri seçin veya yeni müşteri ekleyin.');
      return;
    }
    try {
      if (form.id) {
        await axios.put(`/api/health-tourism/patients/${form.id}`, form, { headers });
      } else {
        await axios.post('/api/health-tourism/patients', form, { headers });
      }
      setModal({ open: false }); setForm({}); setCustomerQuery(''); setCustomerResults([]); setNewCustomerMode(false);
      fetchAll();
    } catch (e) { alert(e.response?.data?.error || 'Hata'); }
  };

  const saveTreatment = async () => {
    try {
      if (form.id) {
        await axios.put(`/api/health-tourism/treatments/${form.id}`, form, { headers });
      } else {
        await axios.post('/api/health-tourism/treatments', form, { headers });
      }
      setModal({ open: false }); setForm({}); fetchAll();
    } catch (e) { alert(e.response?.data?.error || 'Hata'); }
  };

  const deletePatient = async (id) => {
    if (!window.confirm('Hasta silinsin mi?')) return;
    await axios.delete(`/api/health-tourism/patients/${id}`, { headers });
    fetchAll();
  };

  const statusColors = {
    inquiry: '#6B7280', consultation: '#3B82F6', approved: '#8B5CF6', scheduled: '#F59E0B',
    arrived: '#10B981', in_treatment: '#EC4899', post_op: '#F97316', discharged: '#6366f1', follow_up: '#14B8A6'
  };
  const statusLabels = {
    inquiry: 'Sorgulama', consultation: 'Konsültasyon', approved: 'Onaylandı', scheduled: 'Planlandı',
    arrived: 'Geldi', in_treatment: 'Tedavide', post_op: 'Post-Op', discharged: 'Taburcu', follow_up: 'Takip'
  };

  if (loading) return <div className="loading"><div className="loading-spinner"></div></div>;

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">🏥 Hasta Takibi</h1>
          <p className="page-subtitle">Sağlık turizmi hasta yönetimi</p>
        </div>
        <div className="header-actions">
          <button className="btn btn-primary" onClick={() => { setForm({}); setCustomerQuery(''); setCustomerResults([]); setNewCustomerMode(false); setModal({ open: true, type: activeTab === 'patients' ? 'patient' : 'treatment' }); }}>
            + {activeTab === 'patients' ? 'Yeni Hasta' : 'Yeni Tedavi'}
          </button>
        </div>
      </div>

      <div className="tabs-bar">
        {[['patients', '👤 Hastalar'], ['treatments', '💊 Tedavi Planları']].map(([k, v]) => (
          <button key={k} className={`tab-btn ${activeTab === k ? 'active' : ''}`} onClick={() => setActiveTab(k)}>{v}</button>
        ))}
      </div>

      {activeTab === 'patients' && (
        <div className="card mt-4">
          <div className="table-container">
            <table className="table">
              <thead>
                <tr>
                  <th>Hasta</th><th>Uyruk</th><th>Tedavi</th><th>Seyahat</th><th>Durum</th><th>İşlem</th>
                </tr>
              </thead>
              <tbody>
                {patients.map(p => (
                  <tr key={p.id}>
                    <td>
                      <div className="font-medium">{p.first_name} {p.last_name}</div>
                      <div className="text-xs text-muted">{p.phone}</div>
                    </td>
                    <td>{p.nationality || '-'}</td>
                    <td>{p.treatment_type || '-'}</td>
                    <td>{p.travel_date ? new Date(p.travel_date).toLocaleDateString('tr-TR') : '-'}</td>
                    <td>
                      <span className="badge" style={{ background: statusColors[p.status] + '20', color: statusColors[p.status] }}>
                        {statusLabels[p.status] || p.status}
                      </span>
                    </td>
                    <td>
                      <div style={{ display: 'flex', gap: '8px' }}>
                        <button className="btn btn-ghost btn-sm" onClick={() => { setForm(p); setCustomerQuery(''); setCustomerResults([]); setNewCustomerMode(false); setModal({ open: true, type: 'patient' }); }}>✏️</button>
                        <button className="btn btn-ghost btn-sm" onClick={() => deletePatient(p.id)}>🗑️</button>
                      </div>
                    </td>
                  </tr>
                ))}
                {patients.length === 0 && <tr><td colSpan="6" className="text-center text-muted" style={{ padding: '40px' }}>Henüz hasta kaydı yok</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {activeTab === 'treatments' && (
        <div className="card mt-4">
          <div className="table-container">
            <table className="table">
              <thead>
                <tr>
                  <th>Hasta</th><th>Tedavi</th><th>Doktor</th><th>Tarih</th><th>Paket Fiyat</th><th>Durum</th>
                </tr>
              </thead>
              <tbody>
                {treatments.map(t => (
                  <tr key={t.id}>
                    <td className="font-medium">{t.first_name} {t.last_name}</td>
                    <td>{t.treatment_name}</td>
                    <td>{t.doctor_name || '-'}</td>
                    <td>{t.scheduled_date ? new Date(t.scheduled_date).toLocaleDateString('tr-TR') : '-'}</td>
                    <td>{t.package_price ? `${Number(t.package_price).toLocaleString('tr-TR')} ₺` : '-'}</td>
                    <td>
                      <span className="badge" style={{ background: t.status === 'completed' ? '#10B98120' : '#F59E0B20', color: t.status === 'completed' ? '#10B981' : '#F59E0B' }}>
                        {t.status === 'planned' ? 'Planlandı' : t.status === 'confirmed' ? 'Onaylandı' : t.status === 'in_progress' ? 'Devam Ediyor' : t.status === 'completed' ? 'Tamamlandı' : 'İptal'}
                      </span>
                    </td>
                  </tr>
                ))}
                {treatments.length === 0 && <tr><td colSpan="6" className="text-center text-muted" style={{ padding: '40px' }}>Henüz tedavi planı yok</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {modal.open && (
        <div className="modal-overlay" onClick={() => setModal({ open: false })}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: '600px' }}>
            <div className="modal-header">
              <h2>{modal.type === 'patient' ? (form.id ? 'Hasta Düzenle' : 'Yeni Hasta') : 'Yeni Tedavi Planı'}</h2>
              <button className="modal-close" onClick={() => setModal({ open: false })}>×</button>
            </div>
            <div className="modal-body">
              {modal.type === 'patient' ? (
                <div className="form-grid" style={{ gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px' }}>
                  <div className="form-group" style={{ gridColumn: 'span 2' }}>
                    <label className="form-label">Müşteri *</label>
                    {form.id ? (
                      <div style={{ padding: '10px 12px', background: 'var(--gray-100, #f1f5f9)', borderRadius: '8px', fontWeight: 500 }}>
                        {form.first_name} {form.last_name}
                      </div>
                    ) : form.customer_id ? (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 12px', background: 'var(--gray-100, #f1f5f9)', borderRadius: '8px' }}>
                        <span style={{ fontWeight: 500, flex: 1 }}>{customerQuery}</span>
                        <button type="button" className="btn btn-ghost btn-sm" onClick={() => { setForm({ ...form, customer_id: undefined }); setCustomerQuery(''); }}>Değiştir</button>
                      </div>
                    ) : !newCustomerMode ? (
                      <>
                        <input className="input" placeholder="İsim veya telefon ile ara..." value={customerQuery} onChange={e => searchCustomers(e.target.value)} />
                        {customerResults.length > 0 && (
                          <div style={{ border: '1px solid var(--border, #e2e8f0)', borderRadius: '8px', marginTop: '4px', maxHeight: '160px', overflowY: 'auto' }}>
                            {customerResults.map(c => (
                              <div key={c.id} style={{ padding: '8px 12px', cursor: 'pointer', borderBottom: '1px solid var(--border, #e2e8f0)' }}
                                onClick={() => selectCustomerForPatient(c)}>
                                <div style={{ fontWeight: 500 }}>{c.first_name} {c.last_name}</div>
                                <div style={{ fontSize: '12px', color: '#64748b' }}>{c.phone}</div>
                              </div>
                            ))}
                          </div>
                        )}
                        <button type="button" className="btn btn-ghost btn-sm" style={{ marginTop: '6px' }} onClick={() => setNewCustomerMode(true)}>+ Yeni Müşteri Ekle</button>
                      </>
                    ) : (
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', padding: '12px', border: '1px solid var(--border, #e2e8f0)', borderRadius: '8px' }}>
                        <input className="input" placeholder="Ad" value={newCustomer.first_name} onChange={e => setNewCustomer({ ...newCustomer, first_name: e.target.value })} />
                        <input className="input" placeholder="Soyad" value={newCustomer.last_name} onChange={e => setNewCustomer({ ...newCustomer, last_name: e.target.value })} />
                        <input className="input" placeholder="Telefon" value={newCustomer.phone} onChange={e => setNewCustomer({ ...newCustomer, phone: e.target.value })} />
                        <div style={{ display: 'flex', gap: '8px' }}>
                          <button type="button" className="btn btn-secondary btn-sm" onClick={() => setNewCustomerMode(false)}>Vazgeç</button>
                          <button type="button" className="btn btn-primary btn-sm" onClick={createCustomerForPatient}>Müşteriyi Oluştur</button>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="form-group"><label className="form-label">Uyruk</label>
                    <input className="input" value={form.nationality || ''} onChange={e => setForm({ ...form, nationality: e.target.value })} />
                  </div>
                  <div className="form-group"><label className="form-label">Pasaport No</label>
                    <input className="input" value={form.passport_number || ''} onChange={e => setForm({ ...form, passport_number: e.target.value })} />
                  </div>
                  <div className="form-group"><label className="form-label">Dil</label>
                    <select className="select" value={form.preferred_language || 'en'} onChange={e => setForm({ ...form, preferred_language: e.target.value })}>
                      <option value="en">English</option><option value="de">Deutsch</option><option value="ar">العربية</option><option value="ru">Русский</option><option value="tr">Türkçe</option>
                    </select>
                  </div>
                  <div className="form-group"><label className="form-label">Tedavi Türü</label>
                    <input className="input" placeholder="Saç ekimi, Diş, vb." value={form.treatment_type || ''} onChange={e => setForm({ ...form, treatment_type: e.target.value })} />
                  </div>
                  <div className="form-group"><label className="form-label">Geliş Tarihi</label>
                    <input type="date" className="input" value={form.travel_date || ''} onChange={e => setForm({ ...form, travel_date: e.target.value })} />
                  </div>
                  <div className="form-group"><label className="form-label">Dönüş Tarihi</label>
                    <input type="date" className="input" value={form.return_date || ''} onChange={e => setForm({ ...form, return_date: e.target.value })} />
                  </div>
                  <div className="form-group" style={{ gridColumn: 'span 2' }}><label className="form-label">Durum</label>
                    <select className="select" value={form.status || 'inquiry'} onChange={e => setForm({ ...form, status: e.target.value })}>
                      {Object.entries(statusLabels).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                    </select>
                  </div>
                  <div className="form-group" style={{ gridColumn: 'span 2' }}><label className="form-label">Tıbbi Geçmiş</label>
                    <textarea className="textarea" rows={3} value={form.medical_history || ''} onChange={e => setForm({ ...form, medical_history: e.target.value })} />
                  </div>
                </div>
              ) : (
                <div className="form-grid" style={{ gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px' }}>
                  <div className="form-group"><label className="form-label">Hasta</label>
                    <select className="select" value={form.patient_id || ''} onChange={e => setForm({ ...form, patient_id: e.target.value })}>
                      <option value="">Seçin</option>
                      {patients.map(p => <option key={p.id} value={p.id}>{p.first_name} {p.last_name}</option>)}
                    </select>
                  </div>
                  <div className="form-group"><label className="form-label">Tedavi Adı</label>
                    <input className="input" value={form.treatment_name || ''} onChange={e => setForm({ ...form, treatment_name: e.target.value })} />
                  </div>
                  <div className="form-group"><label className="form-label">Doktor</label>
                    <input className="input" value={form.doctor_name || ''} onChange={e => setForm({ ...form, doctor_name: e.target.value })} />
                  </div>
                  <div className="form-group"><label className="form-label">Paket Fiyat (₺)</label>
                    <input type="number" className="input" value={form.package_price || ''} onChange={e => setForm({ ...form, package_price: e.target.value })} />
                  </div>
                  <div className="form-group"><label className="form-label">Planlanan Tarih</label>
                    <input type="datetime-local" className="input" value={form.scheduled_date || ''} onChange={e => setForm({ ...form, scheduled_date: e.target.value })} />
                  </div>
                  <div className="form-group"><label className="form-label">Süre (gün)</label>
                    <input type="number" className="input" value={form.duration_days || 1} onChange={e => setForm({ ...form, duration_days: e.target.value })} />
                  </div>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={() => setModal({ open: false })}>İptal</button>
              <button className="btn btn-primary" onClick={modal.type === 'patient' ? savePatient : saveTreatment}>Kaydet</button>
            </div>
          </div>
        </div>
      )}

      <style>{`
        .tabs-bar { display: flex; gap: 4px; background: var(--gray-100, #f1f5f9); padding: 4px; border-radius: 12px; margin-top: 16px; }
        .tab-btn { padding: 10px 20px; border: none; background: transparent; color: var(--gray-600, #475569); font-weight: 500; cursor: pointer; border-radius: 8px; transition: all 0.2s; }
        .tab-btn.active { background: white; color: var(--gray-900, #0f172a); box-shadow: 0 1px 3px rgba(0,0,0,0.1); }
        .mt-4 { margin-top: 16px; }
      `}</style>
    </div>
  );
}

export default PatientTracking;
